// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__7fEzL","container":"styles_container__3BvTv","title":"styles_title__2xaOu","wrapper":"styles_wrapper__30URt","answer":"styles_answer___vWfV"};